/** Visual tokens for Third Eye / print-style report surfaces (RWD-friendly). */
export const reportLayoutTokens = {
  /** Table header row background (light warm tint). */
  tableHeaderBg: "#FAF6F0",
  /** Muted label color on header cells. */
  tableHeaderText: "#7A5C52",
  /** Alternate table header (e.g. top items fluctuations). */
  tableHeaderBgAlt: "#F9F6F2",
  tableHeaderTextAlt: "#344054",
  /** Rounded table container. */
  cardBorder: "1px solid #EAECF0",
  cardRadius: 2,
  /** Purchase reference / link accent. */
  refLink: "#9B2C2C",
} as const;
